export default [13, 14, 24, 25, 35, 36, 46, 41, 51, 52, 62, 63]
